import { getSchema } from '../../decorators/utilities/get.merge.schema';
import { MergeField } from '../../decorators/decorators/merge.field';
import { MergeSchema } from '../../decorators/decorators/merge.schema';
import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';

@MergeSchema({
    entity: ActivityEntityName.Site
})
export class AccountSiteMergeData {

    @MergeField()
    street: string;

    @MergeField()
    suburb: string;

    @MergeField()
    state: string;

    @MergeField()
    postcode: string;

    @MergeField()
    fullAddress: string;

    @MergeField()
    contactName: string;

    @MergeField()
    contactPhone: string;

    @MergeField()
    contactEmail: string;


}

export const AccountSiteMergeSchema = getSchema(AccountSiteMergeData);